export default {

  SET_OwnersPaymentLogs(state,  OwnersPaymentLogs) {
    state.OwnersPaymentLogs =  OwnersPaymentLogs;
  },

};

